import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-invite-close",
  "use": "icon-invite-close-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-invite-close\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h44v44H0z\" /><path d=\"M35.96 11.014 24.974 22 35.96 32.986a1 1 0 0 1 0 1.414l-1.56 1.56a1 1 0 0 1-1.414 0L22 24.974 11.014 35.96a1 1 0 0 1-1.414 0L8.04 34.4a1 1 0 0 1 0-1.414L19.026 22 8.04 11.014a1 1 0 0 1 0-1.414L9.6 8.04a1 1 0 0 1 1.414 0L22 19.026 32.986 8.04a1 1 0 0 1 1.414 0l1.56 1.56a1 1 0 0 1 0 1.414Z\" fill=\"#1A1A1A\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol